import React from 'react';
import { observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BASE_IMG_URL, commonImage, setPostImage } from '@images/imageUrls';
import TabFilter from '@components/tabFilter';
import Avatar from '@components/avatar';
import CommentInput from '@components/commentInput/h5';
import InfiniteScrollList from '@components/InfiniteScrollList';
import parse from 'html-react-parser';
import classNames from 'classnames';
import CommonPopup from '@components/commonPopup';
import CommonAlert from '@components/commonAlert';
import Toast from '@components/Toast';
import { Radio, Input, DatePickerProps, DatePicker } from 'antd';
import { formatTime } from '@utils/timeUtils'; // 相对路径
import { Image } from 'antd';
import updateImageListSrc from "@utils/update-image-list-src";
import { px2rem } from '@utils/px2rem';
import { replaceEmojiCodes } from '@utils/emoji';
import CommentBubble from '../commentBubble';
const { TextArea } = Input;

interface PCPostListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    threadId: any   // 帖子id
    threadType: any // 帖子类型
    commentType?: number  // 发布评论时的 type 参数（0 帖子评论，2 活动评论）
    filterList?: any    // 筛选类型
    filterClick?: any   // 筛选点击事件
    filterCurrentIndex?: any  // 筛选当前选中的索引
    postList?: any   // 评论列表数据
    hasMore?: boolean
    loading?: boolean
    onLoadMore?: () => void
    onPostLike?: (data: any) => void  // 评论点赞事件（与 pc 对齐）
    deletePopupStatus?: any
    reportPopupStatus?: any
    reportReasonList?: any
    reportReason?: any
    reportDescription?: any
    handleSetState?: any
    handleDeletPost?: Function    // 删除评论事件
    handleReportPost?: Function    // 删除评论事件
    onDeleteComment?: (itemId: any) => Promise<void>  // 删除评论回调
    onSinkComment?: (itemId: any, currentIsSink?: boolean) => Promise<void>    // 沉贴评论回调，传入当前是否已沉贴
    onStickyComment?: (itemId: any, currentIsSticky?: boolean) => Promise<void>  // 置顶评论回调，传入当前是否已置顶
}
interface H5PostListState {
    menuDropStatusIndex: any
    selectedItemId?: any
    selectedItemType?: any
    replyingCommentId?: any
    replyingCommentIndex?: any
    replyingType?: 'post' | 'comment'
    replyingMainPostId?: any
    commentInputVisible?: boolean
    tempPostList?: any[]
    actionSheetVisible?: boolean
    actionSheetTarget?: {
        id: any
        type: 'main' | 'nested'
        mainId?: any
        nestedIndex?: number
    } | null
    currentItemData?: any
    selectedCommentIsSink?: boolean
    selectedCommentIsSticky?: boolean
    expandedReplies?: { [key: string]: { list: any[], hasMore: boolean, lastId: number, loading: boolean } }
    lowQualityExpanded?: boolean
    // deletePopupStatus: any
    // reportPopupStatus: any
    // reportReasonList: any
    // reportReason: any
    // reportDescription: any
}

@inject('app', 'site', 'user', 'thread')
@observer
class H5PostList extends React.Component<PCPostListProps, H5PostListState> {
    state: H5PostListState = {
        menuDropStatusIndex: '',  // 评论列表管理下拉框状态
        selectedItemId: '',
        selectedItemType: '',
        replyingCommentId: '',
        replyingCommentIndex: -1,
        replyingType: 'post',
        replyingMainPostId: '',
        commentInputVisible: false,
        tempPostList: [],
        actionSheetVisible: false,
        actionSheetTarget: null,
        currentItemData: null,
        selectedCommentIsSink: false,
        selectedCommentIsSticky: false,
        expandedReplies: {},
        lowQualityExpanded: false,
        // reportPopupStatus: false,    // 举报弹框
        // reportReasonList:[
        //     { value: '淫秽色情', label: '淫秽色情' },
        //     { value: '垃圾广告', label: '垃圾广告' },
        //     { value: '暴力恐怖', label: '暴力恐怖' },
        //     { value: '违规传播', label: '违规传播' },
        //     { value: '政治谣言', label: '政治谣言' },
        //     { value: '谩骂侮辱', label: '谩骂侮辱' },
        //     { value: '灌水发帖/评论', label: '灌水发帖/评论' },
        //     { value: '其他', label: '其他' },
        // ],
        // reportReason: '',   // 举报理由
        // reportDescription: '',  // 举报描述
        // deletePopupStatus: false,   // 删除弹框状态
    };
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    private replaceEmojiInContent = (content?: string) => replaceEmojiCodes(content || '', this.props.site?.emojiList || []);

    private showActionSheet = (target: { id: any; type: 'main' | 'nested'; mainId?: any; nestedIndex?: number; itemData?: any }) => {
        // 从 HTML 内容中提取纯文本用于复制
        const extractPlainText = (htmlContent: string) => {
            if (!htmlContent) return '';
            // 创建临时 DOM 元素来解析 HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlContent;
            return tempDiv.textContent || tempDiv.innerText || '';
        };

        const plainText = target.itemData?.plainText || extractPlainText(target.itemData?.content || '');

        // 与父级同步当前选中项
        this.setState({
            actionSheetVisible: true,
            actionSheetTarget: target,
            selectedItemId: target.id,
            selectedItemType: 'comment',
            currentItemData: {
                ...target.itemData,
                plainText, // 确保有纯文本可以复制
            },
            selectedCommentIsSink: target.itemData?.isSink || false,
            selectedCommentIsSticky: target.itemData?.isSticky || false,
        });
        this.props.handleSetState?.({ selectedCommentId: target.id });
    };

    private hideActionSheet = () => {
        this.setState({ actionSheetVisible: false });
    };

    // 加载楼中楼评论
    handleLoadMoreReplies = async (mainPostId: any, lastCommentId?: any) => {
        const { thread } = this.props;
        if (!thread) return;

        const { expandedReplies = {} } = this.state;
        const current = expandedReplies[mainPostId] || { list: [], hasMore: true, lastId: 0, loading: false };

        if (current.loading || !current.hasMore) return;

        // 设置加载状态
        this.setState({
            expandedReplies: {
                ...expandedReplies,
                [mainPostId]: { ...current, loading: true }
            }
        });

        try {
            const params: any = { 'page[size]': 5 };
            // 优先使用传入的 lastCommentId（楼中楼最后一条的 ID），否则使用 state 中保存的 lastId
            const queryLastId = lastCommentId || current.lastId;
            if (queryLastId) {
                params['filter[idLt]'] = queryLastId;
            }

            const res = await thread.getPostComments(mainPostId, params);

            if (res.success && res.data?.data) {
                const newList = res.data.data || [];
                const hasMore = res.data.page?.hasMore || false;
                const lastId = newList.length > 0 ? newList[newList.length - 1].id : current.lastId;

                this.setState({
                    expandedReplies: {
                        ...expandedReplies,
                        [mainPostId]: {
                            list: [...current.list, ...newList],
                            hasMore,
                            lastId,
                            loading: false
                        }
                    }
                });
            } else {
                this.setState({
                    expandedReplies: {
                        ...expandedReplies,
                        [mainPostId]: { ...current, loading: false }
                    }
                });
            }
        } catch (error) {
            console.error('加载楼中楼评论失败:', error);
            this.setState({
                expandedReplies: {
                    ...expandedReplies,
                    [mainPostId]: { ...current, loading: false }
                }
            });
        }
    };

    // 切换低质评论展开状态
    toggleLowQuality = () => {
        this.setState({ lowQualityExpanded: !this.state.lowQualityExpanded });
    };

    // 显示评论输入框
    handleShowCommentInput = () => {
        this.setState({ commentInputVisible: true });
    };

    // 隐藏评论输入框
    handleHideCommentInput = () => {
        this.setState({ commentInputVisible: false });
    };

    // 处理筛选点击
    handleFilterClick = (item: any, index: number) => {
        console.log('导航点击:', { item, index });

        // 调用父组件传递的函数
        const { filterClick } = this.props;
        if (filterClick) {
            filterClick(item, index);
        }
    }

    // 删除评论/帖子
    handleDeleteItem = async (itemId: any, itemType: 'post' | 'comment') => {
        if (this.props.onDeleteComment) {
            try {
                await this.props.onDeleteComment(itemId);
            } catch (error) {
                Toast.error({ content: '删除失败' });
            }
        }
    }

    // 沉贴
    handleSinkItem = async (itemId: any, currentIsSink?: boolean) => {
        if (this.props.onSinkComment) {
            try {
                await this.props.onSinkComment(itemId, currentIsSink);
            } catch (error) {
                Toast.error({ content: '沉贴失败' });
            }
        }
    }

    // 置顶
    handleTopItem = async (itemId: any, currentIsSticky?: boolean) => {
        if (this.props.onStickyComment) {
            try {
                await this.props.onStickyComment(itemId, currentIsSticky);
            } catch (error) {
                Toast.error({ content: '置顶失败' });
            }
        }
    }

    // 点赞乐观更新，主评与楼中楼都立即同步
    handleLikeClick = (target: any, parentId?: any) => {
        if (!target) return;
        const payload = { ...target };
        const nextLiked = !target.isLiked;
        const nextCount = Math.max(0, (target.likeCount || 0) + (nextLiked ? 1 : -1));

        // 顶层评论直接更新
        if (!parentId || parentId === target.id) {
            this.props.thread?.listStore?.updateListItem?.({
                namespace: 'postList',
                id: target.id,
                updates: { isLiked: nextLiked, likeCount: nextCount },
            });

            this.setState((prev) => ({
                tempPostList: (prev.tempPostList || []).map((item) =>
                    (item.id || item.tempId) === target.id ? { ...item, isLiked: nextLiked, likeCount: nextCount } : item,
                ),
            }));
        } else {
            // 楼中楼：更新父评论的最后三条 + 展开列表
            const { postList = [] } = this.props as any;
            const parent = postList.find((p: any) => p?.id === parentId);
            if (parent) {
                const patchedLastThree = (parent.lastThreeComments || []).map((c: any) =>
                    c?.id === target.id ? { ...c, isLiked: nextLiked, likeCount: nextCount } : c,
                );
                this.props.thread?.listStore?.updateListItem?.({
                    namespace: 'postList',
                    id: parentId,
                    updates: { lastThreeComments: patchedLastThree },
                });
            }

            this.setState((prev) => {
                const expanded = prev.expandedReplies?.[parentId];
                if (!expanded) return null as any;
                const patchedList = (expanded.list || []).map((c: any) =>
                    c?.id === target.id ? { ...c, isLiked: nextLiked, likeCount: nextCount } : c,
                );
                return {
                    expandedReplies: {
                        ...prev.expandedReplies,
                        [parentId]: { ...expanded, list: patchedList },
                    },
                } as any;
            });
        }

        this.props.onPostLike?.(payload);
    }

    // 复制内容
    handleCopyItem = (content: string) => {
        if (!content) {
            Toast.info({ content: '无内容可复制' });
            return;
        }

        try {
            // 使用 Clipboard API
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                navigator.clipboard.writeText(content).then(() => {
                    Toast.success({ content: '已复制' });
                    this.resetMenuState();
                }).catch(() => {
                    this.fallbackCopy(content);
                });
            } else {
                // 降级方案
                this.fallbackCopy(content);
            }
        } catch (error) {
            Toast.error({ content: '复制失败' });
        }
    }

    // 降级复制方案
    fallbackCopy = (text: string) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
            Toast.success({ content: '已复制' });
            this.resetMenuState();
        } catch (error) {
            Toast.error({ content: '复制失败' });
        }
        document.body.removeChild(textarea);
    }

    // 重置菜单状态
    resetMenuState = () => {
        this.setState({
            menuDropStatusIndex: '',
            selectedItemId: '',
            selectedItemType: ''
        });
    }

    // 提交主评论，直接本地插入，避免等待刷新
    handleSubmitMainComment = async (data: { content: string; images: any[]; newComment?: any }) => {
        if (!data?.newComment) {
            Toast.info('评论失败');
            return;
        }

        Toast.success('评论成功');
        this.handleHideCommentInput();
        this.setState(prev => ({ tempPostList: [data.newComment, ...(prev.tempPostList || [])] }));
        this.props.thread?.prependPostToList?.(data.newComment);
        const { handleSetState, postList = [], onLoadMore } = this.props as any;
        if (typeof handleSetState === 'function') {
            handleSetState({ postList: [data.newComment, ...postList] });
        } else {
            onLoadMore?.();
        }
    };

    // 开启回复输入 - 与 pc 对齐：支持二级回复定位
    handleReplyComment = (commentId: any, commentUser?: any, commentIndex: any = -1, mainPostId?: any) => {
        const isNestedReply = commentIndex !== -1 && !!mainPostId;
        this.setState({
            replyingCommentId: commentId,
            replyingCommentIndex: isNestedReply ? commentIndex : -1,
            replyingMainPostId: isNestedReply ? mainPostId : commentId,
            replyingType: 'comment'
        });
    };

    // 取消回复
    handleCancelReply = () => {
        this.setState({
            replyingCommentId: '',
            replyingCommentIndex: -1,
            replyingType: 'post',
            replyingMainPostId: ''
        });
    };

    // 提交回复，更新本地列表
    // 提交回复 - 参照 iqoo-mini 的逻辑区分一级和二级回复
    handleSubmitReply = async (data: { content: string; images: any[]; newComment?: any }) => {
        if (!data?.newComment) {
            Toast.info('评论失败');
            return;
        }

        // 先保存 state 值，避免 handleCancelReply 清空后取不到
        const { replyingCommentId, replyingCommentIndex, replyingMainPostId, tempPostList = [] } = this.state;
        const { handleSetState, postList = [], onLoadMore } = this.props as any;

        // 二级回复需要落到所属的主评论下，否则不会即时显示
        const targetMainId = replyingMainPostId || replyingCommentId;

        this.props.thread?.appendReplyToPost?.({ mainPostId: targetMainId, newComment: data.newComment });

        Toast.success('评论成功');
        this.handleCancelReply();

        const applyReply = (list: any[]) => list.map((item: any) => {
            if (item.id !== targetMainId) return item;
            const lastThree = Array.isArray(item.lastThreeComments) ? item.lastThreeComments : [];
            return {
                ...item,
                replyCount: (item.replyCount || 0) + 1,
                lastThreeComments: [...lastThree, data.newComment],
            };
        });

        this.setState({ tempPostList: applyReply(tempPostList) });

        if (typeof handleSetState === 'function') {
            handleSetState({ postList: applyReply(postList) });
        } else {
            onLoadMore?.();
        }
    };

    // // 确定举报
    // reportConfirm = () => {
    //     let { reportReason, handleReportPost } = this.props;
    //     if (reportReason == '') {
    //         Toast.info('请选择举报理由');
    //         return false;
    //     }
    //     handleReportPost && handleReportPost();
    //     // this.props.handleSetState({
    //     //     reportPopupStatus: false
    //     // }, () => {

    //     // })

    // }

    // 确定删除
    deletThreadConfirm = () => {
        let { handleDeletPost } = this.props;
        // 这里调用删除帖子的接口
        // this.props.handleSetState({
        //     deletePopupStatus: false
        // }, () => {

        // })
        handleDeletPost && handleDeletPost();
    }

    // 关闭所有弹框
    closePopup = () => {
        // Toast.info('关闭')
        this.setState({
            menuDropStatusIndex: '',  //右上角下拉框
            selectedItemId: '',
            selectedItemType: ''
        })
        this.props.handleSetState({
            reportPopupStatus: false,   // 举报弹框
            deletePopupStatus: false,   // 删除弹框
        }, () => {

        })
    }

    render() {
        const { thread, threadId, threadType, filterList, filterCurrentIndex, postList = [], user, reportPopupStatus, reportReasonList, reportReason, reportDescription, deletePopupStatus, hasMore, loading, onLoadMore } = this.props;
        let { menuDropStatusIndex, replyingCommentId, replyingCommentIndex, replyingMainPostId, commentInputVisible, tempPostList = [], expandedReplies = {}, lowQualityExpanded } = this.state;
        if (!thread) { return null }
        const threadData: any = thread.threadData;
        // 合并本地临时评论与服务端列表，保证即时展示
        const mergedMap = new Map();
        [...tempPostList, ...postList].forEach((item: any) => {
            if (!item) return;
            const id = item.id || `temp-${Math.random()}`;
            if (!mergedMap.has(id)) mergedMap.set(id, item);
        });
        const allComments = Array.from(mergedMap.values());

        // 分离正常评论和低质评论
        const normalComments = allComments.filter(item => !item.isSink);
        const lowQualityComments = allComments.filter(item => item.isSink);
        const totalCount = allComments.length;
        const shouldCollapseLowQuality = totalCount > 5 && lowQualityComments.length > 0;

        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };

        // 构建渲染项目的函数
        const renderCommentItem = (item: any, index: number) => {
            const expandedData = expandedReplies[item.id] || { list: [], hasMore: true, lastId: 0, loading: false };
            const displayedComments = [...(item.lastThreeComments || []), ...expandedData.list];
            // remainingCount = 总回复数 - 当前已显示的楼中楼条数
            const remainingCount = (item.replyCount || 0) - displayedComments.length;
            const showExpandButton = remainingCount > 0 && expandedData.hasMore;

            return (
                <div className={styles.postItemBox} key={item?.id || index}>
                    {/* 分割线 */}
                    <div className={styles.postGap}></div>
                    <div className={classNames(styles.postItem, menuDropStatusIndex === `item-${index}` ? styles.menuDrop : '')} >
                        {/* 主评论 */}
                        <Avatar avatarUrl={item.user?.avatar} titleMark={item.user?.titleMark} level={item.user?.level} size={80} userCode={item.user?.code} levelBadgeWidth={36} levelBadgeHeight={24}></Avatar>
                        <div className={styles.itemDetail}>
                            <div className={styles.detailTopBox}>
                                {/* 左侧用户名、头衔 */}
                                <div className={styles.nicknameBox}>
                                    <div className={styles.nickname}>{item.user?.nickname}</div>
                                    <div className={styles.titleName}>{item.user?.titleName}</div>
                                    {(threadData?.user?.code == item.user?.code) && <div className={styles.masterText}>楼主</div>}
                                </div>
                                {/* 右侧点赞、回复、管理菜单 */}
                                <div className={styles.postOperaBox}>
                                    <div className={styles.likedOpera} onClick={() => this.handleLikeClick(item)}>
                                        {!item.isLiked && <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon} />}
                                        {item.isLiked && <img src={`${BASE_IMG_URL}/common/liked.png`} alt="" className={styles.icon} />}
                                        {item.likeCount != 0 && <div className={classNames(styles.likeText, item.isLiked ? styles.isLiked : '')}>{item.likeCount}</div>}
                                    </div>
                                    <div className={styles.menuBox}>
                                        <div className={styles.menuIcon} onClick={() => {
                                            window.globalEnsureLogin(() => {
                                                this.showActionSheet({ id: item.id, type: 'main', itemData: item });
                                            });
                                        }}></div>
                                        <div className={styles.menuDropListBox}>
                                            <div className={styles.menuDropItem} onClick={() => window.globalEnsureLogin(() => {
                                                this.setState({ selectedItemId: item.id, selectedItemType: 'comment' });
                                                this.props.handleSetState({
                                                    selectedCommentId: item.id,
                                                    reportCommentId: item.id,
                                                    reportPopupStatus: true,
                                                    reportType: 2,
                                                });
                                            })}>举报</div>
                                            <div className={classNames(styles.menuDropItem, styles.delete)} onClick={() => window.globalEnsureLogin(() => {
                                                this.handleDeleteItem(item.id, 'comment');
                                            })}>删除</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* 评论内容 */}
                            <CommentBubble decoration={item?.commentDecoration} platform="h5">
                                <div className={styles.richtext}>
                                    {parse(this.replaceEmojiInContent(item?.content || ''), parserOptions)}
                                </div>
                            </CommentBubble>
                            {/* 评论图片 */}
                            {item?.images?.length > 0 && <div className={styles.postImgListBox}>
                                {item?.images.map((img, imgIndex) =>
                                    <Image
                                        className={styles.nestedCommentImage}
                                        key={img.id || imgIndex}
                                        height={110}
                                        src={img.webpUrl || updateImageListSrc(img.url, 12)}
                                        alt="basic"
                                        style={{ 
                                            width: '100%', 
                                            height: '110px',
                                            objectFit: 'cover' 
                                        }}
                                        preview={{ mask: '预览' }}
                                    />
                                )}
                            </div>}
                            {/* 底部信息 */}
                            <div className={styles.postBottomInfo}>
                                <div className={styles.postTime}>{formatTime(item.createdAt)}</div>
                                {item.source && <div className={styles.model}>{item.source}</div>}
                                <div className={styles.model}>{item.ipRegion}</div>
                            </div>
                        </div>
                    </div>

                    {/* 回复一级评论的输入框 */}
                    {replyingMainPostId === item.id && replyingCommentIndex === -1 && (
                        <div className={styles.replyInputWrapper}>
                            <CommentInput
                                type="reply"
                                threadId={threadId}
                                postId={item.id}
                                commentType={this.props.commentType}
                                replyToUser={item.user}
                                onSubmit={this.handleSubmitReply}
                                onCancel={this.handleCancelReply}
                            />
                        </div>
                    )}

                    {/* 评论的回复 */}
                    {displayedComments && displayedComments.length > 0 && displayedComments.map((comment: any, commentIndex: any) => (
                        <React.Fragment key={`nested-${comment.id || commentIndex}`}>
                            <div className={classNames(styles.postItem, styles.commentItem, menuDropStatusIndex === `comment-${index}-${commentIndex}` ? styles.menuDrop : '')}>
                                {/* 二级评论 */}
                                <Avatar avatarUrl={comment.user?.avatar} titleMark={comment.user?.titleMark} level={comment.user?.level} size={32} officialSize={12} userCode={comment.user?.code}></Avatar>
                                <div className={styles.itemDetail}>
                                    <div className={styles.detailTopBox}>
                                        {/* 左侧用户名、头衔 */}
                                        <div className={styles.nicknameBox}>
                                            <div className={styles.nickname}>{comment.user?.nickname}</div>
                                            <div className={styles.titleName}>{comment.user?.titleName}</div>
                                            {(threadData?.user?.code == comment.user?.code) && <div className={styles.masterText}>楼主</div>}
                                        </div>
                                        {/* 右侧点赞、回复、管理菜单 */}
                                        <div className={styles.postOperaBox}>
                                            <div className={styles.likedOpera} onClick={() => this.handleLikeClick(comment, item.id)}>
                                                {!comment.isLiked && <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon} />}
                                                {comment.isLiked && <img src={`${BASE_IMG_URL}/common/liked.png`} alt="" className={styles.icon} />}
                                                {comment.likeCount != 0 && <div className={classNames(styles.likeText, comment.isLiked ? styles.isLiked : '')}>{comment.likeCount}</div>}
                                            </div>
                                            <div className={styles.menuBox}>
                                                <div className={styles.menuIcon} onClick={() => {
                                                    this.showActionSheet({ id: comment.id, type: 'nested', mainId: item.id, nestedIndex: commentIndex, itemData: comment });
                                                }}></div>
                                                <div className={styles.menuDropListBox}>
                                                    <div className={styles.menuDropItem} onClick={() => {
                                                        window.globalEnsureLogin(() => {
                                                            this.setState({ selectedItemId: comment.id, selectedItemType: 'comment' });
                                                            this.props.handleSetState({
                                                                selectedCommentId: comment.id,
                                                                reportPopupStatus: true,
                                                                reportType: 2,
                                                            });
                                                        })
                                                    }}>举报</div>
                                                    <div className={classNames(styles.menuDropItem, styles.delete)} onClick={() => {
                                                        this.handleDeleteItem(item.id, 'comment');
                                                    }}>删除</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* 评论内容 */}
                                    <CommentBubble decoration={comment?.commentDecoration} platform="h5">
                                        <div className={styles.richtext} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline' }}>
                                            {comment?.commentUser?.nickname ? (
                                                <span className={styles.replyPrefix} style={{ marginRight: 2 }}>回复 {comment.commentUser.nickname}：</span>
                                            ) : null}
                                            <span>{parse(this.replaceEmojiInContent(comment?.content || ''), parserOptions)}</span>
                                        </div>
                                    </CommentBubble>
                                    {/* 评论图片 */}
                                    {comment?.images?.length > 0 && <div className={styles.postImgListBox}>
                                        {comment?.images.map((img, imgIndex) =>
                                            <Image
                                                className={styles.nestedCommentImage}
                                                key={img.id || imgIndex}
                                                width={110}
                                                height={110}
                                                src={img.webpUrl || updateImageListSrc(img.url, 12)}
                                                alt="basic"
                                                style={{ 
                                                    objectFit: 'cover' 
                                                }}
                                                preview={{ mask: '预览' }}
                                            />
                                        )}
                                    </div>}
                                    {/* 底部信息 */}
                                    <div className={styles.postBottomInfo}>
                                        <div className={styles.postTime}>{formatTime(comment.createdAt)}</div>
                                        {comment.source && <div className={styles.model}>{comment.source}</div>}
                                        <div className={styles.model}>{comment.ipRegion}</div>
                                    </div>
                                </div>
                            </div>
                            {/* 回复二级评论的输入框 */}
                            {replyingMainPostId === item.id && replyingCommentId === comment.id && replyingCommentIndex === commentIndex && (
                                <div className={styles.nestedReplyInputWrapper}>
                                    <CommentInput
                                        type="reply"
                                        threadId={threadId}
                                        postId={item.id}
                                        commentPostId={comment.id}
                                        commentType={this.props.commentType}
                                        replyToUser={comment.user}
                                        onSubmit={this.handleSubmitReply}
                                        onCancel={this.handleCancelReply}
                                    />
                                </div>
                            )}
                        </React.Fragment>
                    ))}

                    {/* 查看全部回复按钮 */}
                    {showExpandButton && (
                        <div className={styles.expandRepliesBtn} onClick={() => {
                            // 传入楼中楼最后一条的 ID，用于分页查询
                            const lastCommentId = displayedComments.length > 0 ? displayedComments[displayedComments.length - 1].id : 0;
                            this.handleLoadMoreReplies(item.id, lastCommentId);
                        }}>
                            {expandedData.loading ? '加载中...' : `查看全部${remainingCount}条回复`}
                            <img src={commonImage.arrowB2} alt="" className={styles.arrowIcon} />
                        </div>
                    )}
                </div>
            );
        };

        const hasLowQualitySection = lowQualityComments.length > 0;
        const showNoMoreAfterLowQuality = hasLowQualitySection && !loading && !hasMore && allComments.length > 0;
        const hasServerCount = typeof threadData?.postCount === 'number' ? threadData.postCount > 0 : false;
        const hasComments = allComments.length > 0 || postList.length > 0 || hasServerCount;
        const hideEmpty = !!hasComments;

        return <>
            <div className={styles.postListContainer}>
                <div className={styles.postListTitleBox}>
                    <div className={styles.tit}>全部评论 {threadData?.postCount}</div>
                    <TabFilter filterList={filterList} currentIndex={filterCurrentIndex} filterClick={(item: any, filterIndex: any) => this.handleFilterClick(item, filterIndex)}></TabFilter>
                </div>
                {/* 评论入口，点击显示评论组件 */}
                {!commentInputVisible && (
                    <div className={styles.commentEnterBox} onClick={() => window.globalEnsureLogin(this.handleShowCommentInput)}>
                        <Avatar avatarUrl={user?.avatar} titleMark={user?.titleMark} level={user?.userInfo?.level} size={80} userCode={user?.code}></Avatar>
                        <div className={styles.commentEnter}>
                            <div className={styles.placeholder}>分享脑洞</div>
                            <img src={`${BASE_IMG_URL}/common/setPost/photoBar.png`} alt="" className={styles.icon} />
                            <img src={`${BASE_IMG_URL}/common/setPost/expression.png`} alt="" className={styles.icon} />
                        </div>
                    </div>
                )}

                {/* 评论输入框 - 展开状态 */}
                {commentInputVisible && (
                    <CommentInput
                        type="post"
                        threadId={threadId}
                        commentType={this.props.commentType}
                        onSubmit={this.handleSubmitMainComment}
                        onCancel={this.handleHideCommentInput}
                    />
                )}

                {/* 使用 InfiniteScrollList 组件 */}
                <InfiniteScrollList
                    variant="h5"
                    data={normalComments}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={renderCommentItem}
                    emptyText={hideEmpty ? '' : '暂无评论'}
                    emptyIcon={hideEmpty ? '' : setPostImage.emptyPosts}
                    emptyActionText={hideEmpty ? '' : '抢先分享脑洞'}
                    onEmptyAction={this.handleShowCommentInput}
                    className={styles.postList}
                    noMoreText={hasLowQualitySection ? '' : undefined}
                />
                {/* 低质评论区域 */}
                {shouldCollapseLowQuality && !lowQualityExpanded && (
                    <div className={styles.lowQualityToggle} onClick={this.toggleLowQuality}>
                        <span className={styles.foldedText}>已折叠 {lowQualityComments.length} 条相似评论</span>
                        <div className={styles.viewMoreBox}>
                            <span>查看更多</span>
                            <img src={commonImage.arrowB2} alt="" className={styles.arrowIcon} />
                        </div>
                    </div>
                )}

                {/* 显示低质评论 - 使用与普通评论相同的渲染函数 */}
                {((shouldCollapseLowQuality && lowQualityExpanded) || (!shouldCollapseLowQuality && lowQualityComments.length > 0)) && lowQualityComments.map((item: any, index: any) => (
                    <React.Fragment key={`low-${item?.id || index}`}>
                        {renderCommentItem(item, normalComments.length + index)}
                    </React.Fragment>
                ))}

                {showNoMoreAfterLowQuality && (
                    <div className={styles.noMoreText}>没有更多了</div>
                )}
            </div>
            {/* 底部操作面板（举报/删除/沉贴/置顶/取消） */}
            {this.state.actionSheetVisible && (
                <div className={styles.actionSheetOverlay} onClick={this.hideActionSheet}>
                    <div className={styles.actionSheet} onClick={(e) => e.stopPropagation()}>

                        <div className={styles.actionSheetItem} onClick={() => {
                            window.globalEnsureLogin(() => {
                                const { actionSheetTarget } = this.state;
                                if (!actionSheetTarget) return;

                                const { id, type, mainId, nestedIndex } = actionSheetTarget;
                                const itemData = this.state.currentItemData;

                                // 判断是一级评论还是二级评论
                                if (type === 'nested' && mainId !== undefined && nestedIndex !== undefined) {
                                    // 二级评论回复
                                    this.handleReplyComment(id, itemData?.user, nestedIndex, mainId);
                                } else {
                                    // 一级评论回复
                                    this.handleReplyComment(id, itemData?.user, -1);
                                }

                                this.hideActionSheet();
                            });
                        }}>回复</div>

                        <div className={styles.actionSheetItem} onClick={() => {
                            const content = this.state.currentItemData?.plainText || '';
                            this.handleCopyItem(content);
                            this.hideActionSheet();
                        }}>复制</div>

                        <div className={styles.actionSheetItem} onClick={() => {
                            const id = this.state.selectedItemId;
                            this.props.handleSetState?.({
                                selectedCommentId: id,
                                reportPopupStatus: true,
                                reportType: 2,
                            });
                            this.hideActionSheet();
                        }}>举报</div>
                        {this.state.currentItemData?.permissions?.canDelete && <div className={classNames(styles.actionSheetItem, styles.danger)} onClick={() => {
                            const id = this.state.selectedItemId;
                            this.handleDeleteItem(id, 'comment');
                            this.hideActionSheet();
                        }}>删除</div>}
                        {this.state.actionSheetTarget?.type === 'main' && this.state.currentItemData?.permissions?.canSink && <div className={styles.actionSheetItem} onClick={async () => {
                            const id = this.state.selectedItemId;
                            const currentIsSink = this.state.selectedCommentIsSink;
                            await this.handleSinkItem(id, currentIsSink);
                            this.hideActionSheet();
                        }}>{this.state.selectedCommentIsSink ? '取消沉贴' : '沉贴'}</div>}
                        {this.state.actionSheetTarget?.type === 'main' && this.state.currentItemData?.permissions?.canSticky && <div className={styles.actionSheetItem} onClick={async () => {
                            const id = this.state.selectedItemId;
                            const currentIsSticky = this.state.selectedCommentIsSticky;
                            await this.handleTopItem(id, currentIsSticky);
                            this.hideActionSheet();
                        }}>{this.state.selectedCommentIsSticky ? '取消置顶' : '置顶'}</div>}
                        <div className={classNames(styles.actionSheetItem, styles.cancel)} onClick={this.hideActionSheet}>取消</div>
                    </div>
                </div>
            )}
        </>;

    }
}

export default H5PostList;
